import {
  Mail,
  MessageSquare,
  Phone,
  PhoneIncoming,
  PhoneOutgoing,
  type LucideIcon,
} from 'lucide-react';
import type { RecordItem } from '@/lib/api/mappers';

/**
 * The icon of a record's channel in a list row: a chat, an email, or a call by
 * its direction (a plain phone when the direction is unknown). Shared by the
 * embedded lists of records: the dashboard's «Records» tab and the CRM card
 * tab, so the same call reads the same in both.
 */
export function recordChannelIcon(
  record: Pick<RecordItem, 'channel' | 'callDirection'>
): LucideIcon {
  if (record.channel === 'chat') return MessageSquare;
  if (record.channel === 'email') return Mail;
  if (record.callDirection === 'inbound') return PhoneIncoming;
  if (record.callDirection === 'outbound') return PhoneOutgoing;
  return Phone;
}
